import gql from 'graphql-tag';

export const ThemePreferenceSelectorQuery = gql`
	query ThemePreferenceSelectorQuery {
		userPreferences {
			theme
		}
	}
`;
